const SCHEDULE_ID = 'AcZssZ2vdaiZQtVnkA0C75CMBDa9zNGbzXPlt3s5nAxh4VwPcNlsEQlgSRQKdweksR6aVXFByf5yUwOF';
export const EMBED_URL = `https://calendar.google.com/calendar/appointments/schedules/${SCHEDULE_ID}?gv=true`;
export const SHORT_URL = 'https://calendar.app.google/ZWY6Ea9cSns8wDrHA';
